import { baseApi } from '@/services'

interface GenerateSampleDocsResponse {
  is_success: boolean
  message?: string
}

export const sampleContractDocsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateSampleContractDocs: builder.mutation<GenerateSampleDocsResponse, string>({
      query: (externalId) => ({
        url: `v2/applications/${externalId}/generate-sample-documents/`,
        method: 'POST',
      }),
      invalidatesTags: [],
      transformErrorResponse: (response) => {
        return response.data
      },
    }),
  }),
})

export const { useGenerateSampleContractDocsMutation } = sampleContractDocsApi
